import { render, staticRenderFns } from "./fourth.vue?vue&type=template&id=a63ed13a&scoped=true&"
import script from "./fourth.vue?vue&type=script&lang=js&"
export * from "./fourth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63ed13a",
  null
  
)

export default component.exports